import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TerminologyRoutingModule } from './terminology-routing.module';
import { TerminologyComponent } from './terminology/terminology.component';
import { MarketBenchmarksComponent } from './components/market-benchmarks/market-benchmarks.component';
import { TerminalHandlingChargesComponent } from './components/terminal-handling-charges/terminal-handling-charges.component';
import { GeoHierarchyMethodologyComponent } from './components/geo-hierarchy-methodology/geo-hierarchy-methodology.component';
import { ContractLengthComponent } from './components/contract-length/contract-length.component';
import { MarketMetricsComponent } from './components/market-metrics/market-metrics.component';
import { ContractedWithinComponent } from './components/contracted-within/contracted-within.component';
import { ContainerTypesComponent } from './components/container-types/container-types.component';
import { FutureRatesComponent } from './components/future-rates/future-rates.component';
import { CoverageComponent } from './components/coverage/coverage.component';
import { ContractValidityComponent } from './components/contract-validity/contract-validity.component';
import { OceanRateMethodologyComponent } from './components/ocean-rate-methodology/ocean-rate-methodology.component';


@NgModule({
  declarations: [TerminologyComponent,MarketBenchmarksComponent,
    TerminalHandlingChargesComponent,
    GeoHierarchyMethodologyComponent,
    ContractLengthComponent,
    MarketMetricsComponent,
    ContractedWithinComponent,
    ContainerTypesComponent,
    FutureRatesComponent,
    CoverageComponent,
    ContractValidityComponent,
    OceanRateMethodologyComponent],
  imports: [
    CommonModule,
    TerminologyRoutingModule
  ], 
  exports: [MarketBenchmarksComponent,
    TerminalHandlingChargesComponent,
    GeoHierarchyMethodologyComponent,
    ContractLengthComponent,
    MarketMetricsComponent,
    ContractedWithinComponent,
    ContainerTypesComponent,
    FutureRatesComponent,
    CoverageComponent,
    ContractValidityComponent,
    OceanRateMethodologyComponent]
})
export class TerminologyModule { }
